import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkIconModule } from '@nibtravel/shared/ui/components/link-icon';
import { IdOrDefaultModule } from '@nibtravel/shared/ui/directives/id-or-default';
import { ModelsModule } from '@nibtravel/shared/util/models';

import { OptionComponent } from './option.component';
import { CurrencyModule } from '@nibtravel/shared/ui/pipes/currency';

@NgModule({
  imports: [
    CommonModule,
    CurrencyModule,
    IdOrDefaultModule,
    LinkIconModule,
    ModelsModule,
  ],
  declarations: [OptionComponent],
  exports: [OptionComponent],
})
export class OptionModule {}
